import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([{},{}]);

const DisplayFlex360 = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-flex-360');
  
  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} className="display-flex-360" />;
}
export default DisplayFlex360;
